import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Tamanho da página',
	PageOrientation: 'Orientação da página',
	Format: 'Formato',
	DPI: 'DPI',
	Generate: 'Gerar',
	LanguageName: 'Português',
	LanguageCode: 'pt'
};

export default translation;
